import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Button,
  Box,
  Menu,
  FormControlLabel,
  Checkbox,
  TextField,
  Typography,
  Card,
  CardContent,
  Breadcrumbs,
  Stack,
  CircularProgress,
  Alert,
  Fade,
  Paper,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Dialog,
  DialogContent,
  Switch,
  TableSortLabel,
  OutlinedInput,
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { Link, useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import { BUTTON_STYLES } from "../../styles/componentStyles";
import NavBar from "../NavBar";
import api from "../../axiosInstance";
import { useTheme } from "@emotion/react";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteConfirmationDialog from "../DeleteConfirmationDialog";
import { toast, ToastContainer } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import StateModal from "./StateModal";
import SubjectModal from "./SubjectModal";

// Column config and visibility state
const allColumns = [
  {
    key: "id",
    label: "ID",
    cellCss: { align: "center", minWidth: "50px" },
    getValue: (r) => r.id,
  },
  {
    key: "universityId",
    label: "University ID",
    cellCss: { align: "center", minWidth: "100px" },
    getValue: (r) => r.universityId,
  },
  {
    key: "courseId",
    label: "Course ID",
    cellCss: { align: "center", minWidth: "100px" },
    getValue: (r) => r.courseId,
  },
  {
    key: "semesterId",
    label: "Semester ID",
    cellCss: { align: "center", minWidth: "100px" },
    getValue: (r) => r.semesterId,
  },
  {
    key: "regulationYearId",
    label: "Regulation Year ID",
    cellCss: { align: "center", minWidth: "150px" },
    getValue: (r) => r.regulationYearId,
  },
  {
    key: "bookId",
    label: "Book ID",
    cellCss: { align: "center", minWidth: "100px" },
    getValue: (r) => r.bookId,
  },
  {
    key: "bookName",
    label: "Book Name",
    cellCss: { align: "center", minWidth: "100px" },
    getValue: (r) => r.bookName,
  },
  {
    key: "universityName",
    label: "University Name",
    cellCss: { align: "center", minWidth: "150px" },
    getValue: (r) => r.universityName,
  },
  {
    key: "courseName",
    label: "Course Name",
    cellCss: { align: "center", minWidth: "150px" },
    getValue: (r) => r.courseName,
  },
  {
    key: "regulationYearName",
    label: "Regulation Name",
    cellCss: { align: "center", minWidth: "150px" },
    getValue: (r) => r.regulationYearName,
  },
  {
    key: "examName",
    label: "Exam Name",
    cellCss: { align: "center", minWidth: "150px" },
    getValue: (r) => r.examName,
  },

  {
    key: "examType",
    label: "Exam Type",
    cellCss: { align: "center", minWidth: "150px" },
    getValue: (r) => r.examType,
  },
  {
    key: "examDate",
    label: "Exam Date",
    cellCss: { align: "center", minWidth: "150px" },
    getValue: (r) => r.examDate,
  },
  {
    key: "examTime",
    label: "Exam Time",
    cellCss: { align: "center", minWidth: "150px" },
    getValue: (r) => r.examTime,
  },
  {
    key: "examEndTime",
    label: "Exam End Time",
    cellCss: { align: "center", minWidth: "150px" },
    getValue: (r) => r.examEndTime,
  },
  {
    key: "durationMinutes",
    label: "Duration (Minutes)",
    cellCss: { align: "center", minWidth: "150px" },
    getValue: (r) => r.durationMinutes,
  },
  {
    key: "venue",
    label: "Venue",
    cellCss: { align: "center", minWidth: "150px" },
    getValue: (r) => r.venue,
  },
  {
    key: "instructions",
    label: "Instructions",
    cellCss: { align: "center", minWidth: "200px" },
    getValue: (r) => r.instructions,
  },
  {
    key: "active",
    label: "Active",
    cellCss: { align: "center", minWidth: "150px" },
    getValue: (r) => (r.active ? "Yes" : "No"),
  },
  {
    key: "status",
    label: "Status",
    cellCss: { align: "center", minWidth: "150px" },
    getValue: (r) => r.status,
  },
  {
    key: "daysRemaining",
    label: "Days Remaining",
    cellCss: { align: "center", minWidth: "150px" },
    getValue: (r) => r.daysRemaining,
  },
  {
    key: "hoursRemaining",
    label: "Hours Remaining",
    cellCss: { align: "center", minWidth: "150px" },
    getValue: (r) => r.hoursRemaining,
  },
];
const defaultVisibleKeys = new Set([
  "id",
  "bookname",
  "examName",
  "examType",
  "examDate",
  "examTime",
  "examEndTime",
  "universityName",
  "courseName",
  "regulationYearName",
  "venue",
  "instructions",
  "status",
  "active",
]);

const STORAGE_KEY = "examreminderVisibleColumns";

function ExamReminders() {
  const navigate = useNavigate();
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [colleges, setColleges] = useState([]);
  const [examRemainder, setExamRemainder] = useState([]);
  const [openNew, setOpenNew] = useState(false);
  const handleNewClose = () => setOpenNew(false);
  const [selectedexamRemainder, setSelectedexamRemainder] = useState("1" || "");
  const [searchQuery, setSearchQuery] = useState(() => {
    return localStorage.getItem("examRemainder_management") || "";
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [openImage, setOpenImage] = useState(null);
  const [examRemainderEdit, setExamRemainderEdit] = useState(null);
  const [dense, setDense] = useState(true);
  const [orderBy, setOrderBy] = useState("category");
  const [order, setOrder] = useState("asc");
  const [totalElements, setTotalElements] = useState("");

  console.log(examRemainder);

  // Inside sorted Data your component
  const sortedData = useMemo(() => {
    if (!examRemainder) return [];

    return [...examRemainder].sort((a, b) => {
      if (!orderBy) return 0;

      const aValue = a[orderBy];
      const bValue = b[orderBy];

      if (aValue == null) return 1;
      if (bValue == null) return -1;

      if (typeof aValue === "string") {
        return order === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      if (typeof aValue === "number") {
        return order === "asc" ? aValue - bValue : bValue - aValue;
      }

      return 0;
    });
  }, [examRemainder, orderBy, order]);

  // Sorting logic
  const handleSort = (columnKey) => {
    const isAsc = orderBy === columnKey && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(columnKey);
  };

  // padding Dense
  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  //Fetching the University data with examRemainder id
  useEffect(() => {
    setIsLoading(true);
    api
      .get(`/api/admin/exams`, {
        params: {
          size: rowsPerPage,
          page: page,
          search: searchQuery,
        },
      })
      .then((res) => {
        setExamRemainder(res.data.data.content);
        setTotalElements(res.data.data.totalElements);
      })

      .catch((error) => {
        console.error("There was an error fetching the book details!", error);
        setError("Failed to load exam reminders. Please try again.");
      })
      .finally(() => setIsLoading(false));
  }, [page, rowsPerPage, searchQuery]);

  // Initialize from localStorage synchronously to avoid a race with the persister effect
  const [visibleColumns, setVisibleColumns] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const arr = JSON.parse(raw);
        if (Array.isArray(arr)) {
          const validKeys = new Set(allColumns.map((c) => c.key));
          const filtered = arr.filter((k) => validKeys.has(k));
          if (filtered.length > 0) {
            return new Set(filtered);
          }
        }
      }
    } catch {}
    return new Set(Array.from(defaultVisibleKeys));
  });

  const [columnsMenuAnchor, setColumnsMenuAnchor] = useState(null);
  const openColumnsMenu = Boolean(columnsMenuAnchor);

  // Persist column config to localStorage on change
  useEffect(() => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(Array.from(visibleColumns)),
      );
    } catch {}
  }, [visibleColumns]);

  const handleOpenColumnsMenu = (e) => setColumnsMenuAnchor(e.currentTarget);
  const handleCloseColumnsMenu = () => setColumnsMenuAnchor(null);
  const toggleColumn = (key) => {
    setVisibleColumns((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };

  // Helper function to get boolean chip styling
  const getBooleanChip = (value) => {
    const normalized = value === true || value === "true" || value === "Yes";
    return (
      <Chip
        label={normalized ? "Yes" : "No"}
        color={normalized ? "success" : "error"}
        size="small"
        variant="outlined"
      />
    );
  };

  // Helper function to get content type chip styling
  const getContentTypeChip = (type) => {
    const typeConfig = {
      active: { color: "success", label: "ACTIVE" },
      inactive: { color: "error", label: "INACTIVE" },
      //   video: { color: "success", label: "Video" },
      //   link: { color: "info", label: "Link" },
    };
    const config = typeConfig[type?.toLowerCase()] || {
      color: "default",
      label: type || "Unknown",
    };
    return <Chip label={config.label} color={config.color} size="small" />;
  };
  //   Page nation handel changes
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // page nation rows handles
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };
  useEffect(() => {
    setPage(0);
  }, [searchQuery]);

  // pagenation code
  // const sortedData = sortedData;

  // Columns Field showing obeject
  const visibleColumnDefs = allColumns.filter((c) => visibleColumns.has(c.key));
  // Deletion confirm dialog box open and close.
  const handleClickOpen = (id) => {
    setSelectedId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedId(null);
  };
  // Delete The banner record api fetch data
  const handleDelete = async () => {
    try {
      await api.delete(`/api/admin/exams/${selectedId}`);

      // If deletion is successful, update local state update
      setExamRemainder((prev) => prev.filter((row) => row.id !== selectedId));
      toast.success("Record deleted successfully.!", {
        position: "top-right",
        autoClose: 3000,
      });
      setOpen(false);
    } catch (error) {
      console.error("Delete failed:", error);
      toast.error("Failed to delete the record. Please try again.");
    }
  };
  // opening Adding page data in onclick
  const handleNewOpen = () => {
    setOpenNew(true);
    setExamRemainderEdit([]);
  };
  // Editing page data in onclick
  const handleEditClick = (rowData) => {
    handleNewOpen();
    setExamRemainderEdit(rowData);
  };
  // Success show th response values
  const handleFormSuccess = (newItem) => {
    if (!newItem || !newItem.id) {
      console.warn("Invalid item received from form", newItem);
      return;
    }
    setExamRemainder((prev) => {
      const exists = prev.some((item) => item.id === newItem.id);
      console.log(exists);
      if (exists) {
        return prev.map((item) => (item.id === newItem.id ? newItem : item));
      } else {
        return [newItem, ...prev];
      }
    });

    setExamRemainderEdit(null);
  };
  return (
    <>
      {/* <NavBar /> */}
      <ToastContainer />
      {/* Search Section */}
      <Card sx={{ margin: "0 15px", boxShadow: 1 }}>
        <CardContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 1,
            }}
          >
            <TextField
              size="small"
              placeholder="Search exam reminders"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{ minWidth: 260 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
                endAdornment: searchQuery ? (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={() => setSearchQuery("")}
                      edge="end"
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ) : null,
              }}
            />
            {/* <Box
              sx={{
                minWidth: { xs: "80%", md: "50%" },
                display: "flex",
                width: "40%",
                alignItems: "center",
                gap: 2,
              }}
            >
              <FormControl size="small" fullWidth sx={{ maxWidth: 400 }}>
                <InputLabel>Select Univeristy</InputLabel>

                <Select
                  sx={{ textAlign: "left" }}
                  label="Select Univeristy"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  input={<OutlinedInput label="Select Univeristy" />}
                >
                  <MenuItem value="">None</MenuItem>
                  {examRemainder.map((university) => (
                    <MenuItem value={university.id} key={university.id}>
                      {university.id} {"-"} {university.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Typography
                sx={{ display: { xs: "none", md: "block" } }}
                variant="body2"
                color="text.secondary"
              >
                {sortedData.length} of {totalElements} colleges
              </Typography>
            </Box> */}
            <Box sx={{ display: "ned" }}>
              <Box>
                {/* Action Buttons */}
                <Stack
                  direction="row"
                  spacing={2}
                  flexWrap="wrap"
                  useFlexGap
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    gap: 1,
                    flexWrap: { xs: "wrap", md: "nowrap" }, // wrap buttons on mobile
                    mt: { xs: 1, md: 0 },
                    marginRight: "10px",
                  }}
                >
                  <Button
                    variant="outlined"
                    startIcon={<ViewColumnIcon />}
                    onClick={handleOpenColumnsMenu}
                    sx={{
                      minWidth: { xs: "120px", md: "auto" }, // smaller on mobile
                      fontSize: { xs: "10px", md: "12px" },
                    }}
                  >
                    Columns
                  </Button>
                  <Menu
                    anchorEl={columnsMenuAnchor}
                    open={openColumnsMenu}
                    onClose={handleCloseColumnsMenu}
                    PaperProps={{
                      sx: {
                        width: 200,
                        maxHeight: 500,
                        overflowY: "auto",
                        borderRadius: 2,
                      },
                    }}
                  >
                    {allColumns.map((col) => (
                      <FormControlLabel
                        key={col.key}
                        control={
                          <Checkbox
                            checked={visibleColumns.has(col.key)}
                            onChange={() => toggleColumn(col.key)}
                          />
                        }
                        label={col.label}
                        sx={{ pl: 1, pr: 2 }}
                      />
                    ))}
                  </Menu>
                  {/* <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={handleNewOpen}
                    {...BUTTON_STYLES.primary}
                    sx={{
                      minWidth: { xs: "120px", md: "auto" }, // smaller on mobile
                      fontSize: { xs: "10px", md: "12px" },
                    }}
                  >
                    Add Subject Category
                  </Button> */}
                </Stack>
              </Box>
              {/* Dense toggle */}
              <Tooltip title="Dense padding" arrow>
                <FormControlLabel
                  control={
                    <Switch
                      checked={dense}
                      onChange={handleChangeDense}
                      color="primary"
                    />
                  }
                />
              </Tooltip>
            </Box>
          </Box>
          {/* <Typography
            sx={{ display: { xs: "block", md: "none" }, textAlign: "left" }}
            variant="body2"
            color="text.secondary"
          >
            {sortedData.length} of {totalElements} colleges
          </Typography> */}
        </CardContent>
      </Card>
      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      {/* Loading State */}
      {isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      )}
      {!isLoading && (
        <Fade in={!isLoading}>
          <Paper
            sx={{
              width: "98%",
              mx: "auto",
              overflow: "hidden",
              boxShadow: 2,
              marginBottom: "20px",
            }}
          >
            <TableContainer sx={{ maxHeight: 600 }}>
              <Table
                stickyHeader
                aria-label="news table"
                size={dense ? "small" : "medium"}
              >
                <TableHead>
                  <TableRow>
                    {visibleColumnDefs.map((c) => (
                      <TableCell
                        key={c.key}
                        sx={{
                          padding: "10px 5px ",
                          backgroundColor: "#17479e",
                          color: "white",
                          fontWeight: 600,
                          ...c.cellCss,
                          position: "sticky",
                          top: 0,
                          zIndex: 3,
                        }}
                        sortDirection={orderBy === c.key ? order : false}
                      >
                        <TableSortLabel
                          active={orderBy === c.key}
                          direction={orderBy === c.key ? order : "asc"}
                          onClick={() => handleSort(c.key)}
                          sx={{
                            color: "#ffffff !important",
                            "&.Mui-active": {
                              color: "#ffffff !important",
                            },
                            "& .MuiTableSortLabel-icon": {
                              color: "#ffffff !important",
                            },
                          }}
                        >
                          {c.label}
                        </TableSortLabel>
                      </TableCell>
                    ))}
                    <TableCell
                      sx={{
                        backgroundColor: "#17479e",
                        color: "white",
                        fontWeight: 600,
                        minWidth: 120,
                        textAlign: "center",
                        position: "sticky",
                        top: 0,
                        right: 0,
                        zIndex: 4,
                      }}
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {console.log(sortedData)}
                  {Array.isArray(sortedData) && sortedData.length > 0 ? (
                    sortedData.map((row) => (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.id}
                        sx={{
                          "&:nth-of-type(odd)": {
                            backgroundColor: "rgba(0, 0, 0, 0.02)",
                          },
                          "&:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.04)",
                          },
                        }}
                      >
                        {visibleColumnDefs.map((c) => (
                          <TableCell
                            key={c.key}
                            sx={{ padding: "10px 10px", ...c.cellCss }}
                          >
                            {(() => {
                              const value = c.getValue(row);
                              const key = c.key;

                              // Optional debug

                              if (key === "active") {
                                return getBooleanChip(value);
                              }

                              if (key === "status") {
                                return getContentTypeChip(value);
                              }

                              if (key === "image") {
                                return key === "image" ? (
                                  <img
                                    src={`https://siaedutech.com/public/${value}`}
                                    alt="preview"
                                    style={{
                                      width: "60px",
                                      height: "auto",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      setOpenImage(
                                        `https://siaedutech.com/public/${value}`,
                                      )
                                    }
                                  />
                                ) : (
                                  value // show fallback text if not valid image
                                );
                              }

                              return value;
                            })()}
                          </TableCell>
                        ))}
                        <TableCell
                          sx={{
                            align: "center",
                            padding: "10px 10px",
                            minWidth: "120px",
                            position: "sticky",
                            right: 0,
                            backgroundColor: "#fff",
                            zIndex: 1,
                          }}
                        >
                          <Stack
                            direction="row"
                            spacing={0.5}
                            justifyContent="center"
                          >
                            <Tooltip
                              title="Edit Exam remainder"
                              arrow
                              placement="top"
                            >
                              <IconButton
                                color="primary"
                                onClick={() => handleEditClick(row)}
                                size="small"
                                sx={{
                                  "&:hover": {
                                    backgroundColor: "primary.light",
                                    color: "white",
                                  },
                                }}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            {/* <Tooltip
                              title="Course Mapping"
                              arrow
                              placement="top"
                            >
                              <IconButton
                                color="primary"
                                onClick={() =>
                                  navigate("/college_courses", {
                                    state: row.id,
                                  })
                                }
                                size="small"
                                sx={{
                                  "&:hover": {
                                    backgroundColor: "primary.light",
                                    color: "white",
                                  },
                                }}
                              >
                                <NoteAddIcon fontSize="small" />
                              </IconButton>
                            </Tooltip> */}
                            <Tooltip
                              title="Delete Exam Remainder"
                              arrow
                              placement="top"
                            >
                              <IconButton
                                color="error"
                                onClick={() => handleClickOpen(row.id)}
                                size="small"
                                sx={{
                                  "&:hover": {
                                    backgroundColor: "error.light",
                                    color: "white",
                                  },
                                }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={visibleColumnDefs.length + 1}
                        sx={{ textAlign: "center", py: 4 }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 2,
                          }}
                        >
                          <Typography variant="h6" color="text.secondary">
                            {searchQuery
                              ? "No examRemainder found matching your search"
                              : "No examRemainder available"}
                          </Typography>
                          {searchQuery && (
                            <Button
                              variant="outlined"
                              onClick={() => setSearchQuery("")}
                              startIcon={<SearchIcon />}
                            >
                              Clear Search
                            </Button>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            {/* <TablePagination
              rowsPerPageOptions={[10, 30, 50, 100]}
              component="div"
              count={examRemainder.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                borderTop: "1px solid",
                borderColor: "divider",
                "& .MuiTablePagination-toolbar": {
                  paddingLeft: 2,
                  paddingRight: 2,
                },
              }}
            /> */}
          </Paper>
        </Fade>
      )}
      {/* Banner modal */}
      <SubjectModal
        open={openNew}
        onClose={handleNewClose}
        examRemainderEdit={examRemainderEdit}
        onSuccess={handleFormSuccess}
      />
      {/* Confirm Delete Dialog */}
      <DeleteConfirmationDialog
        open={open}
        onClose={handleClose}
        onConfirm={handleDelete}
        title="Confirm Delete"
        message="Are you sure you want to delete this news item? This action cannot be undone."
        confirmText="DELETE"
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
      />
      <Dialog
        open={!!openImage}
        onClose={() => setOpenImage(null)}
        maxWidth="md"
      >
        <DialogContent>
          <Box position="relative">
            <IconButton
              aria-label="close"
              onClick={() => setOpenImage(null)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
            <img
              src={openImage}
              alt="Preview"
              style={{ width: "100%", height: "auto", borderRadius: 4 }}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default ExamReminders;
